<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div
  class="audio-preview-element
  audio-preview-element-{{ content?.type }}
  audio-preview-element-position-{{ content?.position || 'CENTER' }}"
  *ngIf="content?.type === 'MEDIA_UPLOAD'"
  [ngClass]="'audio-preview-element--' + content?.type"
>
  <div class="v3-audio-player">
    <button
      type="button"
      class="v3-audio-player__play-btn"
      (click)="togglePlay()"
      [attr.aria-label]="(isPlaying ? 'translations.global.ariaLabels.pauseAudio' : 'translations.global.ariaLabels.playAudio') | transloco"
    >
      <svg
        [lucideIcon]="isPlaying ? LucidePause : LucidePlay"
        [size]="16"
        class="v3-audio-player__play-icon"
        [class.v3-audio-player__play-icon--play]="!isPlaying"
      ></svg>
    </button>

    <div class="v3-audio-player__body">
      <div
        class="v3-audio-player__track"
        role="slider"
        tabindex="0"
        [attr.aria-label]="'translations.global.ariaLabels.seekAudio' | transloco"
        [attr.aria-valuemin]="0"
        [attr.aria-valuemax]="duration"
        [attr.aria-valuenow]="currentTime"
        (click)="seek($event)"
        (keydown.arrowRight)="skip(5)"
        (keydown.arrowLeft)="skip(-5)"
      >
        <div class="v3-audio-player__track-fill" [style.width.%]="progressPct"></div>
      </div>

      <div class="v3-audio-player__times">
        <span class="v3-audio-player__time">{{ currentTimeLabel }}</span>
        <span class="v3-audio-player__time">{{ durationLabel }}</span>
      </div>
    </div>

    <audio
      #audioElement
      class="v3-audio-player__native"
      [src]="content?.content.url"
      (play)="onPlay()"
      (pause)="onPause()"
      (ended)="onEnded()"
      (timeupdate)="onTimeUpdate()"
      (loadedmetadata)="onLoadedMetadata()"
    ></audio>
  </div>

  <div class="audio-preview-element__caption-box" *ngIf="content?.caption">
    <p tabindex="0" class="caption-text">
      {{ content?.caption }}
    </p>
  </div>
</div>
